<template>
  <div>
    <h4>
      Users Roles Manager -
      <span style="font-weight: bold; color: #eaad11;">FED Service Awards</span>
    </h4>
    <br />
    <p>
      Use this screen to assign one or more roles to specific users.
      <u>You can only assign roles to unlocked users.</u>
    </p>

    <div class="d-flex" style="align-items: center;">
      <div style="flex-grow: 1;">
        <span>Show </span>
        <b-select style="max-width: 100px;" class="ml-1 mr-1" v-model="pg_size">
          <option :value="+10">10</option>
          <option :value="+25">25</option>
          <option :value="+50">50</option>
          <option :value="+100">100</option>
        </b-select>
        <span>entries</span>
      </div>

      <div>
        <div class="d-flex" style="align-items: center;">
          <span>Search:</span>
          <input v-model="search_term" class="form-control ml-1" type="text" name="" id="" style="" />
        </div>
      </div>
    </div>

    <ManageUserRolesTable v-if="!Loading" :sortClients="sortClients" />
    <div v-if="Loading === true">
      <div class="centered-spinner">
        <a-spin />
      </div>
    </div>

    <!-- page Number -->
    <div class="d-flex mb-2" style="align-items: center;" v-if="clientUserData.Result">
      <div style="flex-grow: 1;" class="pl-2">
        <p>
          Showing {{ (pg_num - 1) * pg_size + 1 }} to
          {{ UpperLimit() }}
          of {{ clientUserData.totalRecords }} entries
        </p>
      </div>
      <div class="pr-2">
        <Pagination
          :data="clientUserData.Result"
          :totalPages="Math.ceil(clientUserData.totalRecords / pg_size)"
          :total="clientUserData.totalRecords"
          :perPage="pg_size"
          :currentPage="pg_num"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
    <!-- page Number -->
  </div>
</template>

<script>
import ManageUserRolesTable from './ManageUserRolesTable.vue';
import Pagination from '@/components/Pagination.vue';
export default {
  name: 'ManageUserRoles',
  components: {
    ManageUserRolesTable,
    Pagination,
  },
  data() {
    return {
      search_term: '',
      pg_size: 10,
      pg_num: 1,
      sort_field: '',
      sort_order: '',
      Loading: false,
    };
  },
  computed: {
    client_id() {
      return this.$store.state.user.userClients.client;
    },
    clientUserData() {
      return this.$store.state.settings.clientUsersData;
    },
  },
  watch: {
    pg_size() {
      this.pg_num = 1;
      this.updateData();
    },
    search_term() {
      this.updateData();
    },
    client_id() {
      this.updateData();
    },
  },
  methods: {
    sortClients(sortField) {
      this.Loading = true;
      this.sort_field = sortField;
      this.sort_order = this.sort_order === 'ASC' ? 'DESC' : 'ASC';
      this.updateData();
    },
    onPageChange(page) {
      console.log('page changed', page);
      this.pg_num = page;
      try {
        this.updateData();
      } catch (error) {
        console.log(error);
      }
      window.scrollTo(0, 0);
    },
    UpperLimit() {
      return this.clientUserData.totalRecords < this.pg_num * this.pg_size ? this.clientUserData.totalRecords : this.pg_num * this.pg_size;
    },
    updateData() {
      this.Loading = true;
      this.$store
        .dispatch('settings/getClientUsers', {
          search_term: this.search_term,
          client_id: Number(this.client_id),
          pg_num: this.pg_num,
          pg_size: this.pg_size,
          sort_field: this.sort_field,
          sort_order: this.sort_order,
        })
        .then(() => {
          this.Loading = false;
        });
    },
  },
  created() {
    this.updateData();
  },
};
</script>

<style scoped>
.centered-spinner {
  position: fixed;
  top: 50%;
  left: 62%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
</style>
